module.exports = __webpack_public_path__ + "static/media/Icon3@2x.5ebb403d.png";